<template>
    <section class="pdf-content">
        <section class="report-info">
            <div>
                <div id="header">
                    <div class="logo">
                        <img src="@/assets/images/logo.png"/>
                    </div>
                    <div class="contact">
                        <span>contact@iFindCheaters.com</span>
                        <span>Phillipsburg NJ 08865, USA</span>
                    </div>
                </div>
                <div class="text-block">
                    <p>We offer a variety of services where you can either subscribe or run a search on a
                        profile of a partner where you can find out if your partner has any active or open
                        accounts on over 50 plus dating, social, hook-up apps, Tinder and many more platforms.
                        Our website is <a href="https://ifindcheaters.com/">www.iFindCheaters.com</a> customer
                        runs a search where a report is generated for the search he is looking to run and they
                        can download the report from their dashboard or they can view it after it's done.</p>

                    <p>The customer {{ reports.name }} has signed up for our service and started being a
                        customer on<br/>{{ reports.created_at }}. After signing up for our service the customer has
                        ordered many types of Search Products and or subscribed to a Monthly Subscription that
                        we offer to run a check on his or her partner. The customer has run a bunch of reports
                        which we show in the attachment since being our customer. We looked into the matter and
                        didn't see any fraud from our side. I want to point out that each customer needs to
                        confirm and verify his or her email and identity prior to viewing any reports in which
                        this customer {{ reports.email }} did and verified credentials used to make payment.
                        After all verification is confirmed, that is then when the customer can access their report.
                        We notify all our customers via email that his or her reports are ready for viewing in their
                        account and available for download on our platform once all complete.</p>

                    <p>I am attaching all proof for review including log records as I see this as a person who is
                        not telling the truth, and we are appealing this chargeback. They order a bunch of search
                        reports or subscriptions, run searches, get results, and then file a dispute very fraud-like
                        activity on the side of the customer.</p>

                    <p style="color:#a8a8a8">All Date provided in UTC time zone.</p>
                </div>

                <h1>Customer Profile</h1>
                <table id="user-report-info" class="html2pdf__page-break">
                    <tr>
                        <td>First & Last Name</td>
                        <td>{{ reports.name }}</td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>{{ reports.email }}</td>
                    </tr>
                    <tr>
                        <td>Registered</td>
                        <td>{{ reports.created_at }}</td>
                    </tr>
                    <tr>
                        <td>Accepted Terms & Conditions and Privacy Policy</td>
                        <td>{{ getTerms }}</td>
                    </tr>
                    <tr>
                        <td>Payment ID</td>
                        <td>{{ reports.payment_id }}</td>
                    </tr>
                    <tr>
                        <td>User Status</td>
                        <td>{{ reports.status }}</td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td>{{ getAddress }}</td>
                    </tr>
                    <tr>
                        <td>Date of Last Activity</td>
                        <td>{{ reports.last_activity }}</td>
                    </tr>
                </table>

                <div id="screenshots-container" v-if="screenshots.length" class="html2pdf__page-break">
                    <h1>Screenshots</h1>
                    <div class="" v-for="(screenshot, index) in screenshots">
                        <h3>{{ screenshot.name }}</h3>
                        <img class="html2pdf__image"
                        :src="screenshot.url"
                        :key="index"
                        />
                    </div>
                </div>

                <h1>Payment History</h1>
                <el-table
                    :data="reports.invoices"
                    class="report-table html2pdf__page-break"
                    >
                    <el-table-column prop="number" label="Invoce number"></el-table-column>
                    <el-table-column prop="plan_name" label="Plan Name"></el-table-column>
                    <el-table-column prop="total" label="Amount" width="80"></el-table-column>
                    <el-table-column prop="status" label="Satus" width="80"></el-table-column>
                    <el-table-column prop="date" label="Date" width="170"></el-table-column>
                </el-table>

                <h1>Customer Reports</h1>
                <el-table
                    :data="reports.reports"
                    class="report-table html2pdf__page-break"
                    >
                    <el-table-column prop="id" label="Report ID" width="120"></el-table-column>
                    <el-table-column prop="plan_type" label="Type"></el-table-column>
                    <el-table-column prop="network" label="Searched Network"></el-table-column>
                    <el-table-column prop="date" label="Date"></el-table-column>
                </el-table>

                <h1>Customer Logs</h1>
                <el-table
                    :data="reports.log"
                    :row-class-name="tableRowClassName"
                    class="report-table html2pdf__page-break"
                    >
                    <el-table-column prop="created_at" label="Date" width="160"></el-table-column>
                    <el-table-column prop="ip" label="IP" width="120"></el-table-column>
                    <el-table-column prop="device" label="Device" width="100"></el-table-column>
                    <el-table-column prop="platform" label="Platform" width="140"></el-table-column>
                    <el-table-column prop="browser" label="Browser" width="160"></el-table-column>
                </el-table>

              <h1>Customer Email Logs</h1>
              <el-table
                  :data="reports.email_logs"
                  :row-class-name="tableRowClassName"
                  class="report-table html2pdf__page-break"
              >
                <el-table-column prop="date" label="Date" width="160"></el-table-column>
                <el-table-column prop="from" label="IP" width="120"></el-table-column>
                <el-table-column prop="subject" label="Device" width="100"></el-table-column>
                <el-table-column prop="status" label="Platform" width="140"></el-table-column>
                <el-table-column prop="channel" label="Browser" width="160"></el-table-column>
                <el-table-column prop="ip" label="Browser" width="160"></el-table-column>
                <el-table-column prop="useragent" label="Browser" width="160"></el-table-column>
                <el-table-column prop="messageid" label="Browser" width="160"></el-table-column>
              </el-table>

                <div id="footer" class="text-block">
                    <h1>Additional Information</h1>
                    <p>When a customer signs up to use our service they need to confirm and verify their email
                        address and identity that they are who they are. This customer received the link and did verify their
                        email address which they used to pay via Stripe which was {{ reports.email }}. Screen shots, customer reports,
                        server log information, and email are provided as proof of service.</p>
                    <p>Below I am providing a link to our terms and conditions information from our website as it pertains
                        to all purchases made https://www.ifindcheaters.com/terms for review. I am pointing attention to
                        question number 8 below Fees and Refund Policy states all sales are final.</p>
                    <p>Service Fees, Website, App & In-APP Purchase Refund Policy</p>
                    <p>Fees for use of iFindCheaters.com and all our affiliated service sites are posted on the “Available Plans & Pricing” pages,
                        as well as in the respective purchase fields within the User dashboards. You agree to pay any and all fees associated with
                        your use of our databases by providing us with a valid credit card and you thereby certify that you are authorized to use
                        the credit card you provide. You are responsible for (and must pay for) all use of our databases made by any individual(s)
                        using your account. It is every user’s responsibility to monitor their credit card activity.
                        If you suspect that unauthorized use of your account is taking place, you must notify us immediately.</p>
                    <p>iFindCheaters.com will exert reasonable efforts to deliver the information services to its customers,
                        and to compile the information gathered from selected databases, public records and other sources;
                        provided customer accepts all information "AS IS". This includes but is not limited to: mistakes due
                        to erroneous information provided by the user on the order form as submitted after the user has confirmed
                        the information and acknowledged these terms. Every search that is processed through our systems incurs fixed
                        and/or variable costs for our organization. Furthermore, iFindCheaters.com accesses and is charged for information
                        controlled by third parties and cannot guarantee the accuracy of that information.</p>
                    <p>As such, all service purchases and App purchases are final and no refunds will be provided to You, either in part or in whole,
                        under any circumstances other than your inability to download an App after your purchase due to any technical issues caused by us.
                        We are not responsible for any device specific issues caused by your mobile device or device software.</p>
                    <p>By accepting our terms and policies you understand that we take credit card fraud and non-payment very seriously,
                        and we may work with law enforcement agencies and private parties to address these issues if they occur.
                        We further reserve the right to suspend service to any delinquent account without notice. If you have questions about our fees,
                        please contact us ​here​, before you complete any search.</p>
                    <p>All purchases are final with no refunds. We are not responsible if a dating activity, criminal record or driving record report states
                        “No Account Found” or "0 records found", those results are possible. We are also not responsible if any record that appears contains
                        incorrect information. Record availability and jurisdictional access protocols vary from county to county and state to state.
                        We encourage users to collect and verify as much information as possible before initiating any search. Orders placed are specific
                        and will include only those parameters specified by you, the user.</p><br/>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
export default {
    props: {
        reports: Object,
        screenshots: {
            type: Array,
            default: function(){
                return [];
            }
        }
    },
    data () {
        return {}
    },
    computed:{
        getAddress: function(){
            let address = '';
            if (!this.isExistsReportData()) {
                return '';
            }
            Object.entries(this.reports.address).forEach(([field, value]) => {
                if (value) {
                    address += value+' ';
                }
            });
            return address;
        },
        getTerms: function(){
            if (this.isExistsReportData() & this.reports.accept_terms !== 'undefined' ) {
                return this.reports.accept_terms.date+' ('+this.reports.accept_terms.url+')'
            }
            return '-';
        }
    },
    methods:{
        isExistsReportData: function (){
            return Object.keys(this.reports).length;
        },
        tableRowClassName({row, rowIndex}) {

        }
    },
    mounted() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit("domRendered");
          }, 1000);
        })
    },
  }
</script>

<style scoped lang="scss">

.pdf-content {
    margin: 15px 10px 15px 25px;
    width: 100%;
    background: #fff;

    .report-info {
        display: block;
        padding: 20px 0 0 20px;

        .text-block p{
            text-align: left;
        }

        #header{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-left: 25px;

            .contact{
                display: flex;
                flex-direction: column;
            }

            .logo img{
                width: 170px;
            }
        }

        p {
            text-align: justify;
        }
    }

    .report-table{
        width: 700px;
    }

    #user-report-info td {
        border: 1px solid #ddd;
    }

    .html2pdf__image {
        width: 100%;
        object-fit: cover;
    }

    #screenshots-container{
        padding-left: 5px;
        margin-left: 5px;
    }

    #footer p {
        font-size: 16px;
    }

    #user-report-info tr:nth-child(even){background-color: #f2f2f2;}
}
</style>
